import styled from "styled-components";
import { MenuOutlined } from "@ant-design/icons";
import { theme } from "../../styles/theme";

export const HeaderSection = styled("header")`
  padding: 1.25rem 0;
  background: ${theme.colors.background};
  position: sticky;
  top: 0;
  z-index: 100;
  border-bottom: 1px solid ${theme.colors.border};
`;

export const HeaderInner = styled("div")`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
`;

export const LogoContainer = styled("span")`
  cursor: pointer;
  flex-shrink: 0;
`;

export const NavLinks = styled("nav")`
  display: flex;
  align-items: center;
  gap: 2rem;

  @media only screen and (max-width: 1024px) {
    gap: 1.25rem;
  }
`;

export const NavLink = styled("button")`
  background: none;
  border: none;
  font-family: ${theme.fonts.body};
  font-size: 0.9375rem;
  font-weight: 500;
  color: ${theme.colors.brownMuted};
  cursor: pointer;
  padding: 0;
  transition: color 0.2s ease;

  &:hover {
    color: ${theme.colors.brown};
  }
`;

export const NavLinkStyled = styled("div")`
  display: inline-block;
  text-align: center;
`;

export const CustomNavLinkSmall = styled("div")`
  cursor: pointer;
  flex-shrink: 0;

  button {
    margin-top: 0;
    max-width: none;
    padding: 0.75rem 1.5rem;
  }
`;

export const Burger = styled("div")`
  @media only screen and (max-width: 890px) {
    display: block;
  }

  display: none;
  cursor: pointer;

  svg {
    fill: ${theme.colors.brown};
  }
`;

export const NotHidden = styled("div")`
  display: flex;
  align-items: center;
  gap: 2.5rem;

  @media only screen and (max-width: 890px) {
    display: none;
  }
`;

export const Menu = styled("h5")`
  font-size: 1.2rem;
  font-weight: 600;
  text-align: center;
  font-family: ${theme.fonts.heading};
  color: ${theme.colors.brown};
`;

export const Label = styled("span")`
  font-weight: 500;
  color: ${theme.colors.brown};
  text-align: right;
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  cursor: pointer;
`;

export const Outline = styled(MenuOutlined)`
  font-size: 22px;
  color: ${theme.colors.brown};
`;
